export interface DrawerState {
  isMobileOpen: boolean;
}

export enum DrawerActionTypes {
  OPEN_MOBILE_DRAWER = '@@drawer/OPEN_MOBILE_DRAWER',
  CLOSE_MOBILE_DRAWER = '@@drawer/CLOSE_MOBILE_DRAWER',
}
